export default function Logo({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Nova Creator Logo"
    >
      <defs>
        <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f5a623" />
          <stop offset="100%" stopColor="#c47d12" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="20" fill="#14171f" />
      <rect x="6" y="6" width="88" height="88" rx="16" fill="none" stroke="rgba(139,144,160,0.18)" strokeWidth="1.5" />
      {/* Abstract nova / orbit symbol — solid amber, no glow */}
      <circle cx="50" cy="50" r="9" fill="url(#logoGrad)" />
      <ellipse cx="50" cy="50" rx="30" ry="11" fill="none" stroke="url(#logoGrad)" strokeWidth="2.5" opacity="0.95" transform="rotate(30 50 50)" />
      <ellipse cx="50" cy="50" rx="30" ry="11" fill="none" stroke="url(#logoGrad)" strokeWidth="2.5" opacity="0.55" transform="rotate(90 50 50)" />
      <ellipse cx="50" cy="50" rx="30" ry="11" fill="none" stroke="url(#logoGrad)" strokeWidth="2.5" opacity="0.28" transform="rotate(150 50 50)" />
      {/* Orbiting dots */}
      <circle cx="76" cy="35" r="3" fill="#f5a623" />
      <circle cx="24" cy="65" r="2.5" fill="#c47d12" />
    </svg>
  )
}
